<template>
  <vs-button
    color="danger"
    class="block"
    @click.stop="params.colDef.CellRendererParams.deletePayslip(params.data.id, params.rowIndex)"
    type="filled"
    icon-pack="feather"
    icon="icon-trash"
  ></vs-button>
</template>

<script>
export default {
  name: 'DeleteCell'
}
</script>